import { TiStarOutline } from 'react-icons/ti';

import Divider from '@/components/Divider';
import { useHtmlParser } from '@/hooks/useHtmlParser';

export const BoxNewsTeam = ({ description }: { description: string }) => {
  const { HtmlComponent } = useHtmlParser(description);
  return (
    <div className=" bg-white rounded-md">
      <div className="flex items-center pt-8 gap-2 px-5">
        <figure className="bg-gdt-status-yellow-light w-8 h-8 rounded-full flex items-center justify-center">
          <TiStarOutline className="text-gdt-status-yellow" size={21} />
        </figure>
        <h1 className="text-base font-bold">Lo destacado de la fecha</h1>
      </div>
      <Divider className="bg-gdt-gray-5 mt-4 mb-6" type="horizontal" />
      <HtmlComponent className="px-9 pb-8" />
    </div>
  );
};
